/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Notes_Wifi_Required_TitleInputs */

const en_mobile_notes_wifi_required_title = /** @type {(inputs: Mobile_Notes_Wifi_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes need Wi-Fi`)
};

const es_mobile_notes_wifi_required_title = /** @type {(inputs: Mobile_Notes_Wifi_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las notas necesitan Wi-Fi`)
};

/**
* | output |
* | --- |
* | "Notes need Wi-Fi" |
*
* @param {Mobile_Notes_Wifi_Required_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_notes_wifi_required_title = /** @type {((inputs?: Mobile_Notes_Wifi_Required_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Notes_Wifi_Required_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_notes_wifi_required_title(inputs)
	return en_mobile_notes_wifi_required_title(inputs)
});